import * as t from 'io-ts';
export const ProvisionConnectFileUpload = t.type({
    provisionId: t.string,
    file: t.unknown,
});
//# sourceMappingURL=provision.js.map